
import React from 'react';
import styles from './Authentic.module.css';

import asset1 from '../../../assets/authentic-asset1.png';
import asset2 from '../../../assets/authentic-asset2.png'; 

const Authentic = () => {
  return (
    <section className={styles.icebreakersSection}>
      <div className={styles.imageContainer}>
        <img src={asset1} alt="Asset 1" className={styles.leftImage} />
      </div>
        <h1 className={styles.title}>AUTHENTIC</h1>
        <img src={asset2} alt="Asset 2" className={styles.centerImage} />
        <h2 className={styles.subtitle}>In depth profiles</h2>
    </section>
  );
};

export default Authentic;